module.exports = __webpack_public_path__ + "img/Pista_0422.2916a9f1.png";